import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SignIn } from '@clerk/clerk-react';
import floobizMark from '../assets/floobiz-mark.jpg';
import './AuthShell.css';

const SITE_NAME = process.env.REACT_APP_SITE_NAME || 'Floobiz';

export default function SignInPage() {
  const [params] = useSearchParams();
  const redirectUrl = params.get('redirect_url') || '/buy';

  return (
    <div className="auth-shell">
      <div className="auth-shell-bg" aria-hidden />
      <Link to="/" className="auth-shell-brand">
        <img src={floobizMark} alt={SITE_NAME} />
        <span>{SITE_NAME}</span>
      </Link>
      <div className="auth-shell-card">
        <SignIn
          routing="path"
          path="/sign-in"
          signUpUrl="/sign-up"
          fallbackRedirectUrl={redirectUrl}
          forceRedirectUrl={redirectUrl}
        />
      </div>
      <Link to="/" className="auth-shell-back">← Back to home</Link>
    </div>
  );
}
